import React, { useEffect, useState } from 'react'
import DashboardAuthLayout from '../../layouts/DashboardAuthLayout'
import ChangePassword from './ChangePassword'
import Contact from './Contact'
import Education from './Education'
import Health from './Health'
import Job from './Job'
import Overview from './Overview'
import {
  MenuWrapper,
  TabContentWrapper,
  TabContentWrapperInnerContent,
  TabContentWrapperTitle,
} from './MyProfilePageStyled'
import { Menu } from 'antd'
import { inject, observer } from 'mobx-react'
import NotiPermission from './NotiPermission'
import DashboardLayout from '../../layouts/DashboardLayout'
import AppPageHeader from '../../components/AppPageHeader'

const menuList = [
  {
    key: 'overview',
    title: 'Tổng quan',
  },
  {
    key: 'contact',
    title: 'Thông tin liên hệ',
  },
  {
    key: 'job',
    title: 'Công việc',
  },
  {
    key: 'education',
    title: 'Trình độ học vấn',
  },
  {
    key: 'health',
    title: 'Sức khỏe',
  },
  {
    key: 'change-password',
    title: 'Thay đổi mật khẩu',
  },
  {
    key: 'noti-permission',
    title: 'Cài đặt thông báo',
  },
]

const MyProfilePage = props => {
  const { authenticationStore } = props
  const { setMustChangePassword } = authenticationStore

  const [keyInfoActive, setKeyInfoActive] = useState({
    key: 'overview',
    title: 'Tổng quan',
  })

  const renderInfo = () => {
    if (keyInfoActive.key === 'overview') return <Overview />
    if (keyInfoActive.key === 'contact') return <Contact />
    if (keyInfoActive.key === 'job') return <Job />
    if (keyInfoActive.key === 'education') return <Education />
    if (keyInfoActive.key === 'health') return <Health />
    if (keyInfoActive.key === 'noti-permission') return <NotiPermission />
    if (keyInfoActive.key === 'change-password')
      return (
        <ChangePassword
          onAfterPasswordChanged={() => {
            setKeyInfoActive({
              key: 'overview',
              title: 'Tổng quan',
            })
            setMustChangePassword()
          }}
          onCancel={undefined}
        />
      )
  }

  const onChangeTab = item => {
    setKeyInfoActive({
      key: item.key,
      title: item.item.props.title,
    })

    props.history.push(`/my-profile/${item.key}`)
  }

  useEffect(() => {
    const pathSegment = props.location.pathname.split('/')
    const segmentKey = pathSegment[pathSegment.length - 1]
    const activeItem = menuList.find(item => item.key === segmentKey)
    setKeyInfoActive(activeItem)
  }, [])

  return (
    <DashboardLayout>
      <AppPageHeader title="Thông tin của bạn" />

      <DashboardAuthLayout>
        <div
          style={{ display: 'flex', gap: 24, justifyContent: 'space-between' }}>
          <div style={{ width: 270, flex: '0 0 300px' }}>
            <MenuWrapper
              selectedKeys={[keyInfoActive.key]}
              onSelect={onChangeTab}>
              {menuList.map(menuItem => (
                <Menu.Item key={menuItem.key} title={menuItem.title}>
                  {menuItem.title}
                </Menu.Item>
              ))}
            </MenuWrapper>
          </div>

          <TabContentWrapper>
            <TabContentWrapperTitle>
              {keyInfoActive.title}
            </TabContentWrapperTitle>

            <TabContentWrapperInnerContent>
              {renderInfo()}
            </TabContentWrapperInnerContent>
          </TabContentWrapper>
        </div>
      </DashboardAuthLayout>
    </DashboardLayout>
  )
}

export default inject(
  'authenticationStore',
  'commonStore',
  'loadingAnimationStore'
)(observer(MyProfilePage))
